import { createTheme } from "@mui/material/styles";
import { tokens } from "./tokens";

export const muiTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: tokens.primary, contrastText: tokens.ink },
    secondary: { main: tokens.white },
    background: { default: tokens.surface, paper: tokens.surface100 },
    text: { primary: tokens.white, secondary: tokens.ink3 },
    error: { main: tokens.alert.critical },
    warning: { main: tokens.alert.warning },
    info: { main: tokens.alert.info },
    success: { main: tokens.alert.success },
    divider: "rgba(255,255,255,0.12)",
  },
  typography: {
    fontFamily: ['Roboto', 'system-ui', 'sans-serif'].join(','),
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 9999, paddingInline: 18 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
  },
});
